module.exports = __webpack_public_path__ + "df6775f2ddcdb923906db0863ea6c321.svg";